<!-- Botón en el header -->
<button type="button"
        class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle sw-btn"
        (click)="launch()" [disabled]="capturing"
        aria-label="Reportar un problema" title="Reportar un problema">
  @if (capturing) {
    <span class="spinner-border spinner-border-sm" role="status"></span>
  } @else {
    <i class="bx bx-bug fs-22" aria-hidden="true"></i>
  }
</button>

<!-- Modal -->
@if (open) {
  <div class="sw-overlay" (click)="close()">
    <div class="sw-modal" (click)="$event.stopPropagation()">
      <div class="sw-head">
        <h5><i class="bx bx-bug me-2"></i> Reportar un problema</h5>
        <button type="button" class="sw-x" (click)="close()"><i class="bx bx-x"></i></button>
      </div>

      @if (step === 'form') {
        <div class="sw-body">
          @if (screenshots.length) {
            <div class="sw-shots">
              @for (shot of screenshots; track $index) {
                <div class="sw-shot">
                  <img [src]="shot" alt="Captura {{ $index + 1 }}" />
                  <button type="button" class="sw-shot-x" title="Quitar" (click)="removeShot($index)">
                    <i class="bx bx-x"></i>
                  </button>
                </div>
              }
            </div>
          }

          @if (canAddMore) {
            <div class="sw-capture">
              @if (supportsNative) {
                <button type="button" class="sw-cap-btn primary" (click)="captureNative()" [disabled]="capturing">
                  @if (capturing) { <span class="spinner-border spinner-border-sm"></span> }
                  @else { <i class="bx bx-photo-album"></i> }
                  {{ screenshots.length ? 'Agregar captura' : 'Capturar pantalla' }}
                </button>
              }
              <button type="button" class="sw-cap-btn" [class.primary]="!supportsNative"
                      (click)="captureFast()" [disabled]="capturing">
                @if (capturing && !supportsNative) { <span class="spinner-border spinner-border-sm"></span> }
                @else { <i class="bx bx-camera"></i> }
                {{ supportsNative ? 'Captura rápida sin permiso' : (screenshots.length ? 'Agregar captura' : 'Capturar pantalla') }}
              </button>
            </div>
            @if (supportsNative) {
              <p class="sw-hint sw-cap-hint">La captura recomendada usa el navegador (nítida, no traba la app) y te pedirá elegir esta pestaña. La rápida no pide permiso pero puede tardar en pantallas grandes.</p>
            }
          }

          <label class="sw-label">Título <span class="sw-req">*</span></label>
          <input class="form-control" [(ngModel)]="subject" maxlength="120"
                 placeholder="Resume el problema en una línea" />

          <label class="sw-label">Descripción</label>
          <textarea class="form-control" [(ngModel)]="description" rows="4"
                    placeholder="¿Qué esperabas que pasara y qué pasó? Pasos para reproducirlo…"></textarea>

          <p class="sw-hint"><i class="bx bx-info-circle"></i> Agrega una o varias capturas y adjuntamos datos técnicos para ayudar al equipo de soporte.</p>

          @if (error) { <p class="sw-err">{{ error }}</p> }
        </div>
        <div class="sw-foot">
          <button type="button" class="btn btn-light" (click)="close()">Cancelar</button>
          <button type="button" class="btn btn-primary" (click)="submit()" [disabled]="sending">
            @if (sending) { <span class="spinner-border spinner-border-sm me-1"></span> }
            Enviar reporte
          </button>
        </div>
      } @else {
        <div class="sw-body sw-done">
          <i class="bx bx-check-circle sw-done-icon"></i>
          <h5>¡Reporte enviado!</h5>
          <p>Tu folio es:</p>
          <div class="sw-folio">{{ result?.code }}</div>
          <p class="sw-hint">Puedes completar la información y anotar la captura en el portal de soporte.</p>
        </div>
        <div class="sw-foot">
          <button type="button" class="btn btn-light" (click)="close()">Cerrar</button>
          <a class="btn btn-primary" [href]="result?.portalUrl" target="_blank" rel="noopener">
            <i class="bx bx-link-external me-1"></i> Abrir en el portal
          </a>
        </div>
      }
    </div>
  </div>
}
